module.exports = __webpack_public_path__ + "img/mobi_icon.c3d5cae9.png";